import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosError } from "axios";
import { TAddApplicationData } from "../../types/application";
import {
  TApplication,
  TavoritesContestForHomePage,
  TContestByPublickUrl,
  TContests,
  TDetailsContestForHomePage,
} from "../../types/contests";
import $api, { API } from "../index";
import { TArtist } from "../../types/artists";
import { TAudioTrack } from "../../types/audioTrack";

interface IData extends TAddApplicationData {
  id: string;
}

export const getContests = createAsyncThunk(
  "contestsCards",
  async (_, { rejectWithValue }): Promise<TContests> => {
    try {
      const response = await $api.get(`${API.contestsPath}`);

      return response.data;
    } catch (e: any | AxiosError) {
      if (axios.isAxiosError(e)) {
        const axiosError = e as AxiosError;
        throw rejectWithValue(axiosError);
      }
      throw rejectWithValue(e.message);
    }
  }
);

export const contestCardByPublicUrl = createAsyncThunk(
  "contestCard",
  async (data: string, { rejectWithValue }): Promise<TContestByPublickUrl> => {
    try {
      const response = await $api.get(`${API.contestsPath}/${data}`);

      return response.data;
    } catch (e: any | AxiosError) {
      if (axios.isAxiosError(e)) {
        const axiosError = e as AxiosError;
        throw rejectWithValue(axiosError);
      }
      throw rejectWithValue(e.message);
    }
  }
);

export const addApplication = createAsyncThunk(
  "addApplication",
  async (
    { id, defaultFields, extraFields }: IData,
    { rejectWithValue }
  ): Promise<string> => {
    try {
      const response = await $api.post(
        `${API.contestsPath}/${id}${API.applicationPath}`,
        { defaultFields, extraFields }
      );

      return response.data?.data;
    } catch (e: any | AxiosError) {
      if (axios.isAxiosError(e)) {
        const axiosError = e as AxiosError;
        throw rejectWithValue(axiosError);
      }
      throw rejectWithValue(e.message);
    }
  }
);

export const addRemoveContestsLike = createAsyncThunk(
  "trackAddRemoveContestsLike",
  async (
    data: { contestId: string; audioTrackId: string },
    { rejectWithValue }
  ): Promise<string> => {
    try {
      await $api.post(
        `${API.contestsPath}/${data.contestId}${API.likePath}${data.audioTrackId}`
      );

      return data.audioTrackId;
    } catch (e: any | AxiosError) {
      if (axios.isAxiosError(e)) {
        const axiosError = e as AxiosError;
        throw rejectWithValue(axiosError);
      }
      throw rejectWithValue(e.message);
    }
  }
);

export const detailByContest = createAsyncThunk(
  "detailByContest",
  async (
    data: string,
    { rejectWithValue }
  ): Promise<TDetailsContestForHomePage> => {
    try {
      const response = await $api.get(`${API.contestsPath}/${data}/details`);
      return response.data;
    } catch (e: any | AxiosError) {
      if (axios.isAxiosError(e)) {
        const axiosError = e as AxiosError;
        throw rejectWithValue(axiosError);
      }
      throw rejectWithValue(e.message);
    }
  }
);

export const favoriteByContest = createAsyncThunk(
  "favoriteByContest",
  async (
    data: string,
    { rejectWithValue }
  ): Promise<TavoritesContestForHomePage> => {
    try {
      const response = await $api.get(`${API.contestsPath}/${data}/favorite`);
      return response.data;
    } catch (e: any | AxiosError) {
      if (axios.isAxiosError(e)) {
        const axiosError = e as AxiosError;
        throw rejectWithValue(axiosError);
      }
      throw rejectWithValue(e.message);
    }
  }
);

export const artistsByContest = createAsyncThunk(
  "artistsByContest",
  async (data: string, { rejectWithValue }): Promise<TArtist[]> => {
    try {
      const response = await $api.get(`${API.contestsPath}/${data}/artists`);
      return response.data;
    } catch (e: any | AxiosError) {
      if (axios.isAxiosError(e)) {
        const axiosError = e as AxiosError;
        throw rejectWithValue(axiosError);
      }
      throw rejectWithValue(e.message);
    }
  }
);

export const allTracksByContest = createAsyncThunk(
  "allTracksByContest",
  async (data: string, { rejectWithValue }): Promise<TAudioTrack[]> => {
    try {
      const response = await $api.get(`${API.contestsPath}/${data}/audio`);
      return response.data;
    } catch (e: any | AxiosError) {
      if (axios.isAxiosError(e)) {
        const axiosError = e as AxiosError;
        throw rejectWithValue(axiosError);
      }
      throw rejectWithValue(e.message);
    }
  }
);

export const applicationByContest = createAsyncThunk(
  "applicationByContest",
  async (data: string, { rejectWithValue }): Promise<TApplication> => {
    try {
      const response = await $api.get(
        `${API.contestsPath}/${data}/application`
      );
      return response.data;
    } catch (e: any | AxiosError) {
      if (axios.isAxiosError(e)) {
        const axiosError = e as AxiosError;
        throw rejectWithValue(axiosError);
      }
      throw rejectWithValue(e.message);
    }
  }
);
